import { render, staticRenderFns } from "./CommonOverlay.vue?vue&type=template&id=bcf7b4f8&scoped=true"
import script from "./CommonOverlay.vue?vue&type=script&lang=js"
export * from "./CommonOverlay.vue?vue&type=script&lang=js"
import style0 from "./CommonOverlay.vue?vue&type=style&index=0&id=bcf7b4f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf7b4f8",
  null
  
)

export default component.exports